import { shallowEqual } from '@mnd-frontend/utils';
import { useRef } from 'react';

export default function useMemoObject(object: any) {
  const ref = useRef();
  if (!shallowEqual(object, ref.current)) ref.current = object;
  return ref.current;
}
